import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, StripeElementsOptions } from "@stripe/stripe-js";
import { LocationState, routes } from "~/constants";
import { trackMembershipPayment as track } from "~/events";
import { useClientSecret } from "../hooks";
import { Fields } from "./Fields";

const { VITE_STRIPE_PUBLISHABLE_KEY } = import.meta.env;
const stripePromise = loadStripe(VITE_STRIPE_PUBLISHABLE_KEY);

const appearance: StripeElementsOptions["appearance"] = {
  variables: {
    fontFamily: "Moderat, sans-serif",
  },
};

const spinner = (
  <Flex justify="center" mt="10rem" w="full">
    <Spinner color="fg-accent" size="xl" />
  </Flex>
);

const SubmitCallbackByType = {
  plus: track.submitPlus,
  premium: track.submitPremium,
};

export const FieldsWrapper: FC = () => {
  const location = useLocation();
  const clientSecret = useClientSecret();
  const state = location.state as LocationState;

  if (!state?.type) return <Navigate to={routes.planSelect} state={state} />;
  if (!clientSecret) return spinner;

  const { type } = location.state as LocationState;
  const handleSubmit = SubmitCallbackByType[type];

  const options: StripeElementsOptions = { appearance, clientSecret };

  return (
    <Flex direction="column" minH="38rem">
      <Elements stripe={stripePromise} options={options}>
        <Fields handleSubmit={handleSubmit} type={type} />
      </Elements>
    </Flex>
  );
};
